<template>
    <Card :title="$t('labels.inventory')">
        <div class="card-body">
            <Fieldset :title="$t('labels.basic_information')">
                <div class="row">
                    <div class="col-12 col-md-6 col-xl-6">
                        <FormGroup :label="$t('labels.warehouse')">
                            <Select
                                :model-value="inventory?.warehouse_id"
                                :selected-value="selectedWarehouse?.name"
                                :options="warehouses"
                                option-key="id"
                                :disabled="true"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-12 col-md-6 col-xl-6">
                        <FormGroup :label="$t('labels.status')">
                            <Select
                                :model-value="selectedStatus?.id"
                                :selected-value="selectedStatus?.name"
                                option-key="id"
                                :options="statuses"
                                @update:model-value="$emit('update:selected-status', $event)"
                            />
                        </FormGroup>
                    </div>
                </div>
            </Fieldset>
        </div>
        <div class="card-footer d-flex justify-content-end flex-wrap" style="gap: .5rem">
            <AppButton color="light" @click="$emit('delete')">
                <i class="icon-trash mr-2"></i>
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton color="indigo" @click="$emit('edit')">
                <i class="icon-floppy-disk mr-2"></i>
                <span>{{ $t('buttons.save') }}</span>
            </AppButton>
        </div>
    </Card>
</template>

<script>
import Card from '../../../../../components/new/CardComponent.vue';
import Fieldset from '../../../../../components/new/AppFieldset.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Select from '../../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

export default {
    name: 'InventoryCard',
    components: {
        Card,
        Fieldset,
        FormGroup,
        Select,
        AppButton
    },
    props: {
        inventory: {
            type: Object,
            default: null
        },
        statuses: {
            type: Array,
            default: () => []
        },
        warehouses: {
            type: Array,
            default: () => []
        },
        selectedStatus: {
            type: Object,
            default: null
        },
        selectedWarehouse: {
            type: Object,
            default: null
        }
    },
    emits: ['update:selected-status', 'edit', 'delete']
}
</script>
